<script>
    import ClaimTypeEnum from '@js/enums/damage/ClaimTypeEnum';
    import ClaimTypeComprehensiveEnum from '@js/enums/damage/ClaimTypeComprehensiveEnum';
    import ClaimTypeDeliveryEnum from '@js/enums/damage/ClaimTypeDeliveryEnum';

    export default {
        props: {
            claimType: {
                type: String,
                required: true,
            },
            claimTypeComprehensive: {
                required: true,
                validator: prop => typeof prop === 'string' || prop === null,
            },
            claimTypeDelivery: {
                required: true,
                validator: prop => typeof prop === 'string' || prop === null,
            },
            customerAttributes: {
                type: Object,
                required: true,
            },
            vehicleAttributes: {
                type: Object,
                required: true,
            },
            isFirstPartyDamage: {
                type: Boolean,
                required: true,
            },
        },
        methods: {
            createClaimTypeElements() {
                const elements = [];

                switch (this.claimType) {
                case ClaimTypeEnum.CASUALTY:
                    elements.push('Haftpflichtschaden');
                    break;
                case ClaimTypeEnum.COMPREHENSIVE:
                    switch (this.claimTypeComprehensive) {
                    case ClaimTypeComprehensiveEnum.FULLY:
                        elements.push('Vollkaskoschaden');
                        break;
                    case ClaimTypeComprehensiveEnum.PARTIALLY:
                        elements.push('Teilkaskoschaden');
                        break;
                    case ClaimTypeComprehensiveEnum.GLASS_DAMAGE:
                        elements.push('Glasschaden');
                        break;
                    }
                    break;
                case ClaimTypeEnum.DELIVERY:
                    switch (this.claimTypeDelivery) {
                    case ClaimTypeDeliveryEnum.TRANSPORT:
                        elements.push('Transportschaden');
                        break;
                    case ClaimTypeDeliveryEnum.WARRANTY:
                        elements.push('Beanstandung');
                        break;
                    }
                    break;
                case ClaimTypeEnum.DEBT_COLLECTION:
                    elements.push('Inkassoakte');
                    break;
                }

                return elements;
            },
            createCustomerAndVehicleElements(createElement) {
                const elements = [];

                if (this.customerAttributes.fullName) {
                    elements.push(createElement('b', this.customerAttributes.fullName))
                    if (this.vehicleAttributes.model) {
                        elements.push(', ')
                    }
                }
                if (this.vehicleAttributes.model) {
                    elements.push(this.vehicleAttributes.model)
                    if (this.vehicleAttributes.licensePlate) {
                        elements.push(', ')
                    }
                }
                if (this.vehicleAttributes.licensePlate) {
                    elements.push(this.vehicleAttributes.licensePlate);
                }

                if (this.isFirstPartyDamage) {
                    elements.push(', Eigenschaden')
                }

                return elements;
            },
        },
        render(createElement) {
            const paragraphs = [];

            const paragraph1 = this.createCustomerAndVehicleElements(createElement);
            if (paragraph1.length !== 0) {
                paragraphs.push(createElement('p', {class: 'mb-1'}, paragraph1));
            }

            const paragraph2 = this.createClaimTypeElements(createElement);
            if (paragraph2.length !== 0) {
                paragraphs.push(createElement('p', {class: 'mb-0'}, paragraph2));
            }

            if (paragraphs.length === 0) {
                return '';
            }

            return createElement('div', {class: 'mt-1'}, paragraphs);
        },
    }
</script>
